import React from 'react';
import styles from "../styles/odds-by-widget.module.scss";
import classNames from "classnames";
import {Link} from "../../../core/components/link/link";
import {APP} from "../../../core/app/consts";
import {EntityLogo} from "../../../core/components/logos/entity-logo";
import {useBookieClick} from "../../../infrastructure/hooks/useBookieClick";
// import {OddsByWidgetContentButton} from "./odds-by-widget.content-button";
import {LINK_REL} from "../../../core/consts";
import {ScoresDisclaimer} from "../../../core/components/scores-disclaimer/scores-disclaimer";

export const OddsByWidgetContent = ({controller, shouldRenderBookmakerLogo}) => {
  const {state} = controller;
  const {bookmaker} = state;

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    urlLink: bookmaker.link,
    source: APP.ANALYTICS.SOURCES.oddsBy
  });

  const bookmakerContainerProps = {
    className: classNames(styles.bookmaker),
    onClick: () => onBookieClick(),
    model: bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER
  }

  const bookmakerLogoProps = {
    entity: bookmaker,
    width: 80,
    height: 24,
  }

  return (
    <div className={classNames(styles.content)}>
      {
        shouldRenderBookmakerLogo ? <Link {...bookmakerContainerProps}>
          <EntityLogo {...bookmakerLogoProps}/>
        </Link> : null
      }
      {/*<div className={classNames(styles.text)}>{text}</div>*/}
      {/*<OddsByWidgetContentButton controller={controller}/>*/}
      <ScoresDisclaimer bookmakers={[bookmaker.id]}/>
    </div>
  )
};
